/**
  # normalice

  Normalize an ice server configuration object (or plain old string) into a format
  that is usable in all browsers supporting WebRTC.  Primarily this module is designed
  to help with the transition of the `url` attribute of the configuration object to
  the `urls` attribute.

  ## Example Usage

  <<< examples/simple.js

**/
var protocols = ['stun:', 'turn:'];

module.exports = function (input) {
  var url = (input || {}).url || input;
  var protocol;
  var parts;
  var output = {}; // if we don't have a string url, then allow the input to passthrough

  if (typeof url != 'string' && !(url instanceof String)) {
    return input;
  } // trim the url string, and convert to an array


  url = url.trim(); // if the protocol is not known, then passthrough

  protocol = protocols[protocols.indexOf(url.slice(0, 5))];

  if (!protocol) {
    return input;
  } // now let's attack the remaining url parts


  url = url.slice(5);
  parts = url.split('@');
  output.username = input.username;
  output.credential = input.credential; // if we have an authentication part, then set the credentials

  if (parts.length > 1) {
    url = parts[1];
    parts = parts[0].split(':'); // add the output credential and username

    output.username = parts[0];
    output.credential = (input || {}).credential || parts[1] || '';
  }

  output.url = protocol + url;
  output.urls = [output.url];
  return output;
};